<div [formGroup]="form" class="filters">
  <ng-container *ngFor="let group of config.filterGroups"
                [formGroupName]="group.controlName">
    <ng-container *ngFor="let filter of sortHotFilters(group.filters)"
                  [ngSwitch]="filter.hotFilter.type">
      <div *ngSwitchCase="TableFilterType.SearchInput" class="search-input-filter">
        <app-hot-search-input-filter (filterApplied)="applyFilterForm()"
                                     (showFilters)="openFilters()"
                                     [previousValue]="filters?.[group.controlName]?.[filter.controlName] ?? ''"
                                     [config]="filter"
                                     [initialForm]="initialForm[group.controlName]"
                                     [controlName]="filter.controlName"
                                     [isMobile]="isMobile$ | async"
                                     [form]="getGroup(group.controlName)">
        </app-hot-search-input-filter>
      </div>
      <div *ngSwitchCase="TableFilterType.Input">
        <app-hot-input-filter (filterApplied)="applyFilterForm()"
                              [config]="filter"
                              [initialForm]="initialForm[group.controlName]"
                              [controlName]="filter.controlName"
                              [form]="getGroup(group.controlName)">
        </app-hot-input-filter>
      </div>
      <div *ngSwitchCase="TableFilterType.Radio">
        <app-hot-radio-filter (filterApplied)="applyFilterForm()"
                              [config]="filter"
                              [initialForm]="initialForm[group.controlName]"
                              [controlName]="filter.controlName"
                              [form]="getGroup(group.controlName)"></app-hot-radio-filter>
      </div>
      <div *ngSwitchCase="TableFilterType.DoubleDate">
        <app-hot-double-date-filter (filterApplied)="applyFilterForm()"
                                    [config]="filter"
                                    [initialForm]="initialForm[group.controlName]"
                                    [form]="getGroup(group.controlName).get(filter.controlName)"></app-hot-double-date-filter>
      </div>
    </ng-container>
  </ng-container>
</div>
